'use client'

import { useSyncExternalStore } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'

import type { CookieConsentCategory, CookieConsentService } from './constants'

const CONSENT_CHANGE_EVENT = 'neonwood:cookie-consent-change'

type ConsentSelection = {
  category: CookieConsentCategory
  service?: CookieConsentService
}

export function notifyCookieConsentChange(): void {
  window.dispatchEvent(new Event(CONSENT_CHANGE_EVENT))
}

function subscribeToCookieConsentChange(onStoreChange: () => void): () => void {
  window.addEventListener(CONSENT_CHANGE_EVENT, onStoreChange)

  return () => {
    window.removeEventListener(CONSENT_CHANGE_EVENT, onStoreChange)
  }
}

function isSelectionAccepted({ category, service }: ConsentSelection): boolean {
  try {
    if (!CookieConsent.validConsent()) return false

    return service
      ? CookieConsent.acceptedService(service, category)
      : CookieConsent.acceptedCategory(category)
  } catch {
    return false
  }
}

export function useCookieConsent(selection: ConsentSelection): boolean {
  return useSyncExternalStore(
    subscribeToCookieConsentChange,
    () => isSelectionAccepted(selection),
    () => false,
  )
}

export function showCookiePreferences(): void {
  CookieConsent.showPreferences()
}
